// extracted by mini-css-extract-plugin
export var cardIcon = "_9c-4";
export var checkboxCard = "_9c-0";
export var checkboxCardSelected = "_9c-3";
export var disabled = "_9c-1";
export var outerBorder = "_9c-2";
export var spacerMedium = "_9c-7";
export var spacerSmall = "_9c-6";
export var spacerXsmall = "_9c-5";